import React from 'react'
import { Modal } from 'react-bootstrap'
import classnames from 'classnames'
import { Button } from 'react-bootstrap'
import FileViewer from 'react-file-viewer'
import { Loading } from '..'
import { X } from 'lucide-react'

const DialogBox = ({
  show = false,
  title = 'Modal Title',
  subtitle,
  url,
  custom_class,
  onHide,
  handleHidePdf,
  pdfStatus,
  isPreview,
  children,
  excessOnly
}) => (
  <div>
    {
      <Modal
        show={show}
        dialogClassName={classnames(['custom-modal', custom_class])}
        onHide={onHide}
      >
        <Modal.Header>
          <div className="close-glyph">
            <div aria-hidden="true" onClick={onHide}>
              <X size={16} />
            </div>
          </div>
          <Modal.Title>{title}</Modal.Title>
          {subtitle && subtitle.split('\n').map(sub => {
          return <span className={classnames("modal-subtitle", {
            'excessonly-subtitle': excessOnly == true
          })}>{sub}<br></br></span>
          })}
        </Modal.Header>

        <Modal.Body> {children} </Modal.Body>
      </Modal>
    }
    {isPreview && pdfStatus !== 'failed' && (
      <Modal
        show
        dialogClassName={classnames(['custom-modal-pdf', 'margin-top', custom_class])}
        onHide={() => handleHidePdf()}
      >
        <Modal.Header>
          <div className="close-glyph">
            {url && <Button onClick={() => handleHidePdf()}>Back</Button>}
          </div>
        </Modal.Header>

        <Modal.Body className="modal-body-custom">
          {!url && pdfStatus !== 'failed' && (
            <Loading classes="loading centre-position" />
          )}
          {url && <FileViewer fileType="pdf" filePath={url} />}
        </Modal.Body>
      </Modal>
    )}
  </div>
)

export default DialogBox
